import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class CameraFlash extends XYEffect {
	static key = "CameraFlash";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.AFTER_STATE_UPDATE);
	}
}
